import { defineMessages } from "react-intl";

const messages = defineMessages({
  chooseRecipient: {
    id: "email.creation.previewModal.chooseRecipient",
    defaultMessage: "Choose any recipient to preview as that recipient.",
    description: "email creation modal - Choose Recipient",
  },
  previewAs: {
    id: "email.creation.previewModal.previewAs",
    defaultMessage: "Preview As",
    description: "email creation modal - Preview as text",
  },
  previewAsDescription: {
    id: "email.creation.previewModal.previewAsDescription",
    defaultMessage:
      'The "Preview As" email feature lets you see how an email would look to a particular recipient, helping you check if personalized details are working correctly.',
    description: "email creation modal - Preview as text",
  },
  previewWillShowHere: {
    id: "email.creation.previewModal.previewWillShowHere",
    defaultMessage: "Preview will show here",
    description: "email creation modal - Preview will show here",
  },
});

export default messages;
